// extracted by mini-css-extract-plugin
export var centerText = "_bv-8";
export var container = "_bv-0";
export var doughnutContainer = "_bv-7";
export var legend = "_bv-a";
export var legendItemColorDisplay = "_bv-b";
export var legendItemLabel = "_bv-d";
export var legendItemValue = "_bv-c";
export var lg = "_bv-5";
export var maxWidth = "_bv-9";
export var md = "_bv-4";
export var responsive = "_bv-6";
export var sm = "_bv-3";
export var xs = "_bv-2";
export var xxs = "_bv-1";